//import asyncFactory from "@/client/extensions/modules/asyncComponentFactory.js";

export default [];
